import React, { useState, useEffect } from 'react';
import selectImg from '../../../images/icons/selectWrapper.svg';

const SelectWrapper = ({ children, id, selectedId, onClick }) => {
  const [selected, setSelected] = useState(false);

  useEffect(() => {
    if (selectedId === id) setSelected(true);
    else setSelected(false);
  }, [selectedId]);

  return (
    <div
      onClick={() => onClick(id)}
      className={
        (selected ? 'border border-tealmb ' : '') +
        'xmd:flex-1 xmd:flex-col  xmd:h-48 xmd:shadow-md xmd:hover:shadow-lg cursor-pointer mx-3 mb-3 xmd:mb-0 '
      }
      style={{ borderRadius: '5px' }}
    >
      <div className="relative">
        <img
          className={
            selected ? 'absolute top-0 right-0 z-10 -mr-2 -mt-2' : 'hidden'
          }
          src={selectImg}
          alt="selected"
        />
      </div>
      {children}
    </div>
  );
};

export default SelectWrapper;
